"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    disabled: false,
    isAnswered: false,
    isSafari: false,
    isAutoFilledActive: false,
    onChange: function () {
        // action
    },
    onClick: function () {
        // action
    },
    onBlur: function () {
        // action
    },
    label: '',
    type: 'tel',
    value: '',
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map